import * as THREE from 'three'
import images from './helper/images'
// container
const container = document.querySelector('.three__bg')

// texture loader to load images
const loader = new THREE.TextureLoader()

// Need a scene for the BG
const scene = new THREE.Scene()

// Camera to  capture event. Higher the value = further
const camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 0.1, 1000)

// render
const renderer = new THREE.WebGL1Renderer({
  antialias: true,
})
renderer.setSize(window.innerWidth, window.innerHeight)
container.appendChild(renderer.domElement)

// responsive
window.addEventListener('resize', () => {
  camera.aspect = window.innerWidth / window.innerHeight
  camera.updateProjectionMatrix()
  renderer.setSize(window.innerWidth, window.innerHeight)
})

// Shape 14, 10
// 10 * 16 = 160 points
const geometry = new THREE.PlaneGeometry(16, 10, 15, 9)
const material = new THREE.MeshBasicMaterial({ 
  // color: 0xff0000, 
  map: loader.load(images.bg4), 
  // wireframe: true,
})
// Combine 
const mesh = new THREE.Mesh(geometry, material)

scene.add(mesh, camera)

camera.position.z = 5

// find out how many points in the geometry we can use
const count = geometry.attributes.position.count
console.log(count)

// clock
const clock = new THREE.Clock()

// auto render function
function animate() {
  const time = clock.getElapsedTime()
  for (let i = 0; i < count; i++ ) {
    const x = geometry.attributes.position.getX(i)
    const y = geometry.attributes.position.getY(i)
    // awesome animation
    // geometry.attributes.position.setZ(i, -y * time * 2)
    // animations
    const anim1 = 0.5 * Math.sin(x * 2 + time * 0.7)
    const anim2 = 0.25 * Math.sin(x + time * 0.7)
    const anim3 = 0.1 * Math.sin(y * 15 + time * 0.7)



    // makes it wave
    geometry.attributes.position.setZ(i, anim1 + anim2 + anim3)

    geometry.computeVertexNormals()
    geometry.attributes.position.needsUpdate = true
  }
  requestAnimationFrame(animate)
  // make it rotate
  // mesh.rotation.x += 0.01
  // mesh.rotation.y += 0.01
  renderer.render(scene, camera)
}
animate()